import { PlaceActionType } from './place-action-type';

export interface SetPlaceTagsAction {
  placeKey: string;
  tags: string;
  type: PlaceActionType.SetPlaceTags;
}

export const setPlaceTags = (
  placeKey: string,
  tags: string,
): SetPlaceTagsAction => ({
  placeKey,
  tags,
  type: PlaceActionType.SetPlaceTags,
});
